module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "menu-wrap"
  }, [_l((catalogFilter), function(items) {
    return _h('div', {
      key: items.catalogID,
      staticClass: "menu-items"
    }, [_h('div', {
      staticClass: "menu-catalog"
    }, [_s(items.catalog)]), " ", _l((dishFilter(items.dishs)), function(item) {
      return _h('div', {
        key: item.dishID,
        staticClass: "menu-item"
      }, [_h('div', {
        staticClass: "menu-img"
      }, [_h('img', {
        attrs: {
          "src": item.imgSrc
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            openPicCard(item.imgSrcs)
          }
        }
      })]), " ", _h('div', {
        staticClass: "menu-info"
      }, [_h('div', {
        staticClass: "info-title"
      }, [_h('span', [_s(item.dishName)]), " ", (item.isCombo) ? _h('tag-combo') : _e(), " ", (item.isPromotion) ? _h('tag-promotion') : _e()]), " ", _h('div', {
        staticClass: "info-desc"
      }, [_h('span', [_s(item.dishShortDesc ? item.dishShortDesc : item.dishDesc)])]), " ", _h('div', {
        staticClass: "info-sale"
      }, [_h('span', {
        staticClass: "dish-price"
      }, ["￥" + _s(item.dishPrice)]), " ", _h('span', {
        staticClass: "dish-like"
      }, [_m(0, true), " " + _s(item.likeNum)])])]), " ", _h('div', {
        staticClass: "menu-operation"
      }, [_h('item-oper', {
        attrs: {
          "dish-num": item.dishNum,
          "dish-id": item.dishID,
          "catalog-id": items.catalogID,
          "inside-menu": "true"
        }
      })])])
    })])
  })])
}},staticRenderFns: [function (){with(this) {
  return _h('i')
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-cccda9a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuItems.vue
 ** module id = 79
 ** module chunks = 1
 **/